import moment from 'moment';

export const converters = {
    convertOverrideToClientFormat: function (override) {
        var convertedOverride = JSON.parse(JSON.stringify(override));

        convertedOverride.createTimeStamp = moment(override.createTimeStamp);
        convertedOverride.expireTimeStamp = moment(override.expireTimeStamp);
        return convertedOverride;
    },

    convertOverrideErrorsToClientFormat: function (errors) {
        var overrideUserValidity = {
            userIdValidity: null,
            userIdHelpMessage: null,
            subdivisionValidity: null,
            subdivisionHelpMessage: null,
            startMpValidity: null,
            startMpHelpMessage: null,
            endMpValidity: null,
            endMpHelpMessage: null,
            minuteLimitValidity: null,
            minuteLimitHelpMessage: null,
            numberRequestedValidity: null,
            numberRequestedHelpMessage: null,
            reasonCodeValidity: null,
            reasonCodeHelpMessage: null,
            canSubmit: false
        };

        errors.forEach(function (error) {
            switch (error.field) {
                case "startMp":
                    overrideUserValidity.startMpValidity = "error";
                    overrideUserValidity.startMpHelpMessage = error.message;
                    break;
                case "endMp":
                    overrideUserValidity.endMpValidity = "error";
                    overrideUserValidity.endMpHelpMessage = error.message;
                    break;
                case "minuteLimit":
                    overrideUserValidity.minuteLimitValidity = "error";
                    overrideUserValidity.minuteLimitHelpMessage = error.message;
                    break;
                case "numberRequested":
                    overrideUserValidity.numberRequestedValidity = "error";
                    overrideUserValidity.minuteLimitHelpMessage = error.message;
                    break;
                case "userId":
                    overrideUserValidity.userIdValidity = "error";
                    overrideUserValidity.userIdHelpMessage = error.message;
                default:
                    console.log("Unknown error type was returned from server:", error);
                    break
            }
        });

        return overrideUserValidity;
    }
};